import { apiClient } from '../utils/apiClient'

/** Persists marketing `?code=` from /login until first successful sync with the API. */
export const LOGIN_ATTRIBUTION_LS_KEY = 'veilstream_login_attribution_code'

export const MAX_LOGIN_ATTRIBUTION_LEN = 256

/** Reads `code` from search params and stores trimmed value (max length). Returns true if stored. */
export function persistLoginAttributionCodeFromURL(searchParams: URLSearchParams): boolean {
  const raw = searchParams.get('code')
  if (raw == null || raw.trim() === '') {
    return false
  }
  localStorage.setItem(LOGIN_ATTRIBUTION_LS_KEY, raw.trim().slice(0, MAX_LOGIN_ATTRIBUTION_LEN))
  return true
}

/** Sends pending attribution to the backend once; clears localStorage on success. */
export async function flushLoginAttribution(): Promise<void> {
  const token = localStorage.getItem('github_access_token')
  if (!token?.trim()) return

  const raw = localStorage.getItem(LOGIN_ATTRIBUTION_LS_KEY)
  if (!raw?.trim()) return

  const code = raw.trim().slice(0, MAX_LOGIN_ATTRIBUTION_LEN)

  try {
    await apiClient.post<{ applied: boolean }>(
      '/api/user/login-attribution',
      { code },
      { Authorization: `Bearer ${token}` },
    )
    localStorage.removeItem(LOGIN_ATTRIBUTION_LS_KEY)
  } catch {
    // Keep LS for retry on next auth check
  }
}
